import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'terra-bullet-big-value',
  templateUrl: './bullet-big-value.component.html',
  styleUrls: ['./bullet-big-value.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BulletBigValueComponent {
  @Input() value;
  @Input() toValue;
  @Input() unit;
  @Input() isUnitBeforeValue = false;
  @Input() isGpPreview = false;
  @Input() fractionSize = 2;
}
